import React, { useState } from "react";
import { Alert, Col } from "react-bootstrap";
import { Navigate, useLocation, useParams } from "react-router-dom";
import Select from "react-select";
import states from "../information/USStates.json";
import AnimateWrapper from "../util/AnimateWrapper";
import BasicQuestion from "../util/BasicQuestion";
import { useBreadcrumbs } from "../util/BreadcrumbContext";
import ChoiceCard from "../util/ChoiceCard";

const USState = () => {
    const { state } = useLocation();
    const { usstate } = useParams();
    const { addBreadcrumb } = useBreadcrumbs();
    const [moreInformation, setmoreInformation] = useState(false);

    const information = states[usstate];

    if (
        usstate &&
        !(
            information.max75 ||
            information.state_authorization ||
            information.counties_dry ||
            information.restrictions
        )
    ) {
        return (
            <Navigate
                to="/gift"
                state={{
                    ...state,
                    breadcrumbs: [
                        ...state.breadcrumbs.filter(
                            (item) => item.href !== `/country/${usstate}`
                        ),
                        {
                            href: `/country/${usstate}`,
                            text: information.full_name,
                            disabled: true
                        },
                        { href: "/gift", text: "Geschenk" }
                    ]
                }}
                replace
            />
        );
    }

    return (
        <AnimateWrapper>
            <Alert variant="danger">
                <h2>
                    Zendingen naar de Verenigde Staten zijn officieel niet
                    toegestaan. Doe dit op eigen risico!
                </h2>
                <p>
                    Voor meer informatie{" "}
                    <a
                        href="/"
                        onClick={(e) => {
                            e.preventDefault();
                            setmoreInformation(true);
                        }}
                    >
                        klik hier
                    </a>
                    .
                </p>
                {moreInformation && (
                    <>
                        <p>
                            Voor alle voedsel- en drank verzendingen (óók voor
                            water en óók voor “personal use”) gelden zeer
                            strenge voorwaarden vanuit de Food and Drug
                            Administration (FDA). De zending dient tevoren te
                            zijn aangemeld te zijn (Prior Notice) door de
                            afzender of door de geadresseerde met details over
                            ieder artikel en de betreffende producent (Prior
                            Notice per artikel). Vermeld het Prior notice nummer
                            op de pro forma factuur. Vraag, indien de importeur
                            in de USA niet de Prior Notice regelt, bij ons een
                            Prior Notice formulier, vul dit in en bevestig dit
                            op het pakket. DHL verzorgt dan de indiening bij de
                            FDA.
                        </p>
                        <p>
                            Bij verzending naar een bedrijf met een
                            importvergunning voor alcohol dienen bovendien de
                            USA labellingsvoorschriften te zijn gevolgd
                            (waarschuwingen m.b.t. het gebruik van alcohol), met
                            een Certificate of Label Approval (COLA). B to C
                            zending is eigenlijk niet toegestaan. Wél is in 27
                            staten toegestaan, dat een Amerikaan in Europa ter
                            plekke wijn koopt voor eigen consumptie en deze
                            vervolgens naar zijn huisadres in de USA laat
                            sturen. Er is dan geen import vergunning nodig en
                            behoeft ook niet te worden voldaan aan de speciale
                            labellingsvoorschriften (wél de Prior Notice, zie
                            hierboven). U kunt deze uitweg ook toepassen voor
                            online bestellingen vanuit de USA, dit is op uw
                            risico, maar tot nu toe gaat dat steeds goed. U
                            dient een door de besteller ondertekend LOA
                            formulier (Letter of Acceptance) bij het pakket te
                            voegen. U kunt dit formulier downloaden vanaf onze
                            website.
                        </p>
                    </>
                )}
            </Alert>
            {!usstate ? (
                <BasicQuestion
                    question={"Welke staat wilt u het naartoe versturen?"}
                    answers={
                        <>
                            <Col xs={12} md={6}>
                                <ChoiceCard
                                    header="Kies een staat"
                                    body={
                                        <div className="w-100">
                                            <Select
                                                options={Object.entries(
                                                    states
                                                ).map(([k, v]) => ({
                                                    label: v.full_name,
                                                    value: k
                                                }))}
                                                onChange={({
                                                    label,
                                                    value
                                                }) => {
                                                    addBreadcrumb(
                                                        {
                                                            href: `/state/${value}`,
                                                            text: label
                                                        },
                                                        { USState: value }
                                                    );
                                                }}
                                            />
                                        </div>
                                    }
                                />
                            </Col>
                            <Col xs={12} md={6}>
                                <ChoiceCard
                                    body="De staat staat er niet tussen"
                                    onClick={() => {
                                        addBreadcrumb({
                                            href: "/state-not-supported",
                                            text: "Staat niet ondersteund"
                                        });
                                    }}
                                />
                            </Col>
                        </>
                    }
                />
            ) : (
                <>
                    <Alert variant="danger">
                        <span className="fw-bold">
                            Er zijn specifieke restricties voor het versturen
                            van pakketten naar {information.full_name}:
                        </span>
                        {information.max75 && (
                            <p>
                                Maximaal {information.max75} flessen van 75cl.
                            </p>
                        )}
                        {information.restrictions && (
                            <p>{information.restrictions}</p>
                        )}
                        {information.state_authorization && (
                            <p>State authorization is verplicht.</p>
                        )}
                        {information.counties_dry && (
                            <p>
                                Sommige counties zijn droog (verkoop van alcohol
                                verboden).
                            </p>
                        )}
                    </Alert>

                    <BasicQuestion
                        answers={
                            <>
                                <Col xs={12}>
                                    <ChoiceCard
                                        body={"Klik hier om verder te gaan"}
                                        onClick={() => {
                                            addBreadcrumb({
                                                href: "/gift",
                                                text: "Geschenk"
                                            });
                                        }}
                                    />
                                </Col>
                            </>
                        }
                    />
                </>
            )}
        </AnimateWrapper>
    );
};

export default USState;
